import React, { useState, useEffect } from "react";

//1.name
export const getFullNamev2 = (data) => {
  return data?.data?.name;
};

export const getPhoneNumberv2 = (data) => {
  return data?.data?.mobile_number;
};

export const getEmailv2 = (data) => {
  return data?.data?.email;
};

export const getData = (data) => {
  return data?.data?.id;
};

//Nationality
export const getNationalityv2 = (data) => {
  console.log(data);
  return data?.data?.nationality;
};

export const getStatev2 = (data) => {
  console.log(data);
  return data?.data?.state;
};

//4.prefered program
export const getPreferedProgramv2 = (data) => {
  return data?.data?.programme_interest;
};

//school preference
export const getSchoolPreference = (data) => {
  return data?.data?.school_preference;
};

//level of study
export const getLevelOfStudy = (data) => {
  return data?.data?.level_of_study;
};

//api get info
export const getUserInfov2 = async (submissionID) => {
  //UAT
  // const url = `https://dev.postgrad.taylors.bitlab.services/future-movement-2023/api/open-day-registrations/qrcode?jwt_token=${submissionID}`;
  //PRODUCTION
  // const url = `https://uni.taylors.edu.my/future-movement/api/open-day-registrations/qrcode?jwt_token=${submissionID}`;
  const url = `https://uni.taylors.edu.my/future-movement/api/open-day-registrations/qrcode?qrid=${submissionID}`;
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ jwt_token: submissionID }),
  };

  return fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((e) => {
      return e;
    });
};

//api update info
export const updateInfo = async (id, body) => {
  console.log(body);
  try {
    const response = await fetch(
      //UAT
      // `https://dev.postgrad.taylors.bitlab.services/future-movement-2023/api/open-day-registrations/${id}`,
      //PRODUCTION
      `https://uni.taylors.edu.my/future-movement/api/open-day-registrations/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          //UAT
          // "client-id": "9907ae81-6838-4fdd-932e-e3a76d977457",
          //PRODUCTION
          "client-id": "996a2653-5219-4e7d-b9ad-133c2c4c0457",
          //UAT
          // "client-secret": "6KWkz0HPXiAc4ivEweG0ypVr8Z56kYKULtUApciC",
          //PRODUCTION
          "client-secret": "8RMwIfrqXtGiraSqW6GGi3PIsJhGptZzZ1t4exFo",
        },
        body: JSON.stringify(body),
      }
    );
    console.log(response);
    const json = await response.json();
    return json;
  } catch (error) {
    console.log(error);
    return error;
  }
};

//Api open day attedance
export const getAttendance = async (id, body) => {
  try {
    const userInfo = await getUserInfov2(id);
    const idInfo = userInfo.data.id;
    console.log("userinfo", userInfo);
    console.log("idinfo", idInfo);

    const response = await fetch(`https://uni.taylors.edu.my/future-movement/api/open-day-registrations/${idInfo}/attendance`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "client-id": "996a2653-5219-4e7d-b9ad-133c2c4c0457",
        "client-secret": "8RMwIfrqXtGiraSqW6GGi3PIsJhGptZzZ1t4exFo",
      },
      body: JSON.stringify(body),
    });

    const json = await response.json();
    return json;
  } catch (err) {
    console.log(err);
    return err;
  }
};

//api check queue status
//only check state waiting
export const getQueueStatus = async (id, body) => {
  // const url = "https://one.qbe.ee/taylor/private/private/que_status.json";
  const url = "https://taylor.qbe.ee/taylor_api/taylor_qstatus";

  const userInfo = await getUserInfov2(id);
  console.log(userInfo);
  const email = userInfo?.data?.email;
  const phone = userInfo?.data?.mobile_number;
  console.log("userinfo", userInfo);

  console.log("phone", phone);
  const data = {
    "Access-Token": "gWDtVRTYhmnp4u05VyVKmwblS/8gVnWRgR1i9Nnl0vRlaBRtMXWxq4b8hAV65d3E",
    "case-sensitive": "1",
    // custobj: email,
    mobile: phone,
    filter: ",d,q,ct,tm,dty,tynm,multiserv,s,po,or,sn,lid,stcq,dur,qstts,o,ormm,ct,tm,msn,quecode,cust,rmk",
    is: ",0,16,17",
    ish: ",12,20",
    sort: "dntm",
    type: "questate",
  };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(url, requestOptions);
    if (!response.ok) throw new Error(`Error: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    return error;
  }
};

//add this
//make Api call attendace using after press ok at user info

// export const updateInfo = async (id, body) => {
//   console.log(body);
//   try {
//     const payload = { ...body }; // Create a copy of the body object

//     const response = await fetch(
//       `https://dev.postgrad.taylors.bitlab.services/future-movement-2023/api/open-day-registrations/${id}`,
//       {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           "client-id": "9907ae81-6838-4fdd-932e-e3a76d977457",
//           "client-secret": "6KWkz0HPXiAc4ivEweG0ypVr8Z56kYKULtUApciC",
//         },
//         body: JSON.stringify(payload),
//       }
//     );
//     console.log(response);
//     const json = await response.json();
//     return json;
//   } catch (error) {
//     console.log(error);
//     return error;
//   }
// };

// export const updateInfo = async (id, body) => {
//   console.log(body);
//   try {
//     const response = await fetch(
//       `https://dev.postgrad.taylors.bitlab.services/future-movement-2023/api/open-day-registrations/${id}`,
//       {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           "client-id": "9907ae81-6838-4fdd-932e-e3a76d977457",
//           "client-secret": "6KWkz0HPXiAc4ivEweG0ypVr8Z56kYKULtUApciC",
//         },
//         body: JSON.stringify(body instanceof Object ? body : {}),
//       }
//     );
//     const json = await response.json();
//     return json;
//   } catch (error) {
//     console.log(error);
//     return error;
//   }
// };
